import { render, staticRenderFns } from "./importCateredStudent.vue?vue&type=template&id=78b81058&scoped=true&"
import script from "./importCateredStudent.vue?vue&type=script&lang=js&"
export * from "./importCateredStudent.vue?vue&type=script&lang=js&"
import style0 from "./importCateredStudent.vue?vue&type=style&index=0&id=78b81058&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b81058",
  null
  
)

export default component.exports